import React, { useState } from "react";
import ModalReserveMobile from "./ModalReserveMobile";
import ModalSelectDate from "components/ModalSelectDate";
import converSelectedDateToString from "utils/converSelectedDateToString";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { STANZE_REALI } from "data/villaGrecoDatiStanze/stanze";
import { useParams } from "react-router-dom";
import Avatar from "shared/Avatar/Avatar";



const MobileFooterSticky = () => {
  const [startDate] = useState<Date | null>(new Date("2023/02/06"));
  const [endDate] = useState<Date | null>(new Date("2023/02/23"));
  
  const { id } = useParams<{ id: string }>(); // Ottieni l'ID della stanza
  const stanza = STANZE_REALI.find((item) => item.id === id); // Trova la stanza corrispondente
  
  const nomeHost = process.env.REACT_APP_HOSTNOMECOMPLETO


  return (
    <div className="block lg:hidden fixed bottom-0 inset-x-0 py-2 sm:py-3 bg-white dark:bg-neutral-800 border-t border-neutral-200 dark:border-neutral-6000 z-40">
      <div className="container flex items-center justify-between">
        <div className="">
          {/* <span className="block text-xl font-semibold">
          {stanza ? stanza.price : "N/A"}
            <span className="ml-1 text-sm font-normal text-neutral-500 dark:text-neutral-400">
              /notte
            </span>
          </span> */}
          <div className="flex items-center">
          <Avatar hasChecked sizeClass="h-10 w-10" radius="rounded-full" />
          <span className="ml-2.5 text-neutral-500 dark:text-neutral-400">
            Hosted by{" "}
            <span className="text-neutral-900 dark:text-neutral-200 font-medium">
              {nomeHost}
            </span>
          </span>
        </div>


          {/* <ModalSelectDate
            renderChildren={({ openModal }) => (
              <span
                onClick={openModal}
                className="block text-sm underline font-medium"
              >
                {converSelectedDateToString([startDate, endDate])}
              </span>
            )}
          /> */}
        </div>
        {/* <ModalReserveMobile
          renderChildren={({ openModal }) => (
            <ButtonPrimary
              sizeClass="px-5 sm:px-7 py-3 !rounded-2xl"
              onClick={openModal}
            >
              Prenota Ora
            </ButtonPrimary>
          )}
        /> */}
         <ButtonPrimary href={"/contact"} sizeClass="px-5 sm:px-7 py-3 !rounded-2xl">Contattaci</ButtonPrimary>
      </div>
    </div>
  );
};

export default MobileFooterSticky;
